import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faWarehouse } from '@fortawesome/free-solid-svg-icons';
import { UI_COLORS } from '../../utils/colors';
import { useTranslation } from 'react-i18next';

const UserWarehousesModal = ({ isOpen, onClose, warehouses = [] }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
            style={{ backgroundColor: UI_COLORS.BACKGROUNDS.OVERLAY }}
            onClick={onClose}
        >
            <div
                className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden relative"
                style={{ backgroundColor: UI_COLORS.BACKGROUNDS.CARD }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b" style={{ borderColor: UI_COLORS.BORDERS.LIGHT }}>
                    <h3 className="text-lg font-semibold flex items-center gap-2">
                        <FontAwesomeIcon icon={faWarehouse} className="text-gray-500" />
                        {t('users.warehousesModal.title')}
                    </h3>
                    <button
                        onClick={onClose}
                        className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
                    >
                        <FontAwesomeIcon icon={faTimes} className="text-gray-500" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-4 max-h-[60vh] overflow-y-auto">
                    {warehouses && warehouses.length > 0 ? (
                        <ul className="space-y-2">
                            {warehouses.map((warehouse) => (
                                <li
                                    key={warehouse.id}
                                    className="p-3 rounded-lg border flex items-center gap-3"
                                    style={{
                                        borderColor: UI_COLORS.BORDERS.LIGHT,
                                        backgroundColor: UI_COLORS.BACKGROUNDS.MAIN
                                    }}
                                >
                                    <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600">
                                        <FontAwesomeIcon icon={faWarehouse} size="sm" />
                                    </div>
                                    <span className="font-medium text-gray-700">
                                        {warehouse.name || warehouse.alias_name || `Warehouse #${warehouse.id}`}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className="text-center py-6 text-gray-500">
                            {t('users.warehousesModal.empty')}
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="p-4 border-t bg-gray-50 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg font-medium text-sm transition-colors"
                        style={{
                            backgroundColor: UI_COLORS.BUTTONS.SECONDARY.background,
                            color: UI_COLORS.BUTTONS.SECONDARY.text,
                        }}
                    >
                        {t('common.buttons.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserWarehousesModal;
